import React from "react";
import { useFormikContext } from "formik";
import TextInput from "../../../../../../components/form/text-input";
import Switch from "../../../../../../components/form/switch";
import useUserStore from "../../../../../../stores/user";
import useOrganizationStore from "../../../../../../stores/organization";
import { getSoftLimitWarning } from "../../../../utils/soft-limit";
import styles from "./style.module.scss";

const PinBasedDebit = ({ pricingModel, noMarginTop }) => {
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setValues,
  } = useFormikContext();
  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  const networkFeeFieldName = `${pricingModel}_pin_debit_network_fee`;
  const rateFieldName = `${pricingModel}_pin_debit_rate`;
  const perTransactionFieldName = `${pricingModel}_pin_debit_per_transaction`;

  return (
    <div
      className={`${styles.pinBasedDebitSection} ${noMarginTop ? styles.noMarginTop : ""}`}
    >
      <h6>PIN-BASED DEBIT</h6>
      <div className={styles.pinBasedDebitFields}>
        <Switch
          id={networkFeeFieldName}
          name={networkFeeFieldName}
          label="Enable PIN Debit"
          checked={values[networkFeeFieldName] === "yes"}
          onChange={(e) => {
            const enabled = e.target.checked;
            const networkValue = enabled ? "yes" : "no";
            const rateField = pricingDefaults?.[pricingModel]?.[rateFieldName];
            const perTransactionField =
              pricingDefaults?.[pricingModel]?.[perTransactionFieldName];

            setValues(
              (prev) => ({
                ...prev,
                [networkFeeFieldName]: networkValue,
                [rateFieldName]: enabled ? rateField?.default : 0,
                [perTransactionFieldName]: enabled
                  ? perTransactionField?.default
                  : 0,
              }),
              true,
            );
          }}
          onBlur={handleBlur}
          disabled={nonEditableTemplateOrPricingRestricted}
        />
        <div className={styles.pinBasedDebitInputs}>
          <TextInput
            label={"Debit Rate"}
            placeholder={"0.00"}
            type="text"
            suffix={"%"}
            inputMode="decimal"
            id={rateFieldName}
            name={rateFieldName}
            value={values?.[rateFieldName]}
            onBlur={handleBlur}
            touched={touched?.[rateFieldName]}
            errored={errors?.[rateFieldName]}
            error={errors?.[rateFieldName]}
            hasWarning={
              values[networkFeeFieldName] === "yes" &&
              getSoftLimitWarning(
                pricingDefaults?.[pricingModel]?.[rateFieldName]?.soft_limit,
                values[rateFieldName],
                errors[rateFieldName],
              )
            }
            disabled={
              nonEditableTemplateOrPricingRestricted ||
              values[networkFeeFieldName] === "no"
            }
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: rateFieldName,
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Txn Fee"}
            placeholder={"0.00"}
            type="text"
            prefix={"$"}
            inputMode="decimal"
            id={perTransactionFieldName}
            name={perTransactionFieldName}
            value={values?.[perTransactionFieldName]}
            onBlur={handleBlur}
            touched={touched?.[perTransactionFieldName]}
            errored={errors?.[perTransactionFieldName]}
            error={errors?.[perTransactionFieldName]}
            hasWarning={
              values[networkFeeFieldName] === "yes" &&
              getSoftLimitWarning(
                pricingDefaults?.[pricingModel]?.[perTransactionFieldName]
                  ?.soft_limit,
                values[perTransactionFieldName],
                errors[perTransactionFieldName],
              )
            }
            disabled={
              nonEditableTemplateOrPricingRestricted ||
              values[networkFeeFieldName] === "no"
            }
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: perTransactionFieldName,
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PinBasedDebit;
